module.exports = __webpack_public_path__ + "static/media/barcode.8da84313.svg";